export const FILTER_PREFIX = 'filter';
export const OP_SUFFIX = 'op';
export const VALUE_SUFFIX = 'value';
